import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()

export class AuthService {

  constructor(private http: HttpClient) {}
  
  public getToken(): string {
    return localStorage.getItem('token');
  }

  refreshToken(): Observable<string> {
    return this.http.post<{ accessToken: string }>('/refresh', {}).pipe(map(res => res.accessToken));
  }
  
  //TODO: if required will use this.
  /**
  public isAuthenticated(): boolean {
    // get the token
    const token = this.getToken();
    // return a boolean indicating whether or not the token is expired
    return tokenNotExpired(token);
  }
  */

}
